export default (params) => ({
  trigger: {
    name: 'options_row.select_color_alternative',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_item',
      params: {
        sub_feature: 'options_row_color_overlay',
        method: 'image',
      },
    },
    nonInt: false,
  },
});
